import YourMap from './map';
import MapSizeControl from "./map-size-control";
import { isMobileAndroid } from "./tools";
import Observer from "./observer";
import { localStorageAPI } from './localStorageAPI';

class Editor extends Observer{

    constructor(option) {
        super();
        this.isRouteEditor = option.isRouteEditor;
        this.setMobileAndroidMapSize();
        this.map = new YourMap();
        this.mapSizeControl = new MapSizeControl(this);
        this.searchInputId = 'mapbox-location-search';
    }
    setMobileAndroidMapSize() {
        if(isMobileAndroid()) {
            document.getElementById('map').classList.add('mobile-android');
        }
    }

    init() {
        this.mapSizeControl.init();
        this.map.init();
        if(!this.isRouteEditor){
            this.addGeocoder();
        }
        this.updateLegend(yourMap);
        this.setActiveStyleClass(yourMap.style);
        this.setEvents();
        this.onMapLoaded().then(() => {
            this.publish('initial:load:finish')
        });
    }

    onMapLoaded(){
        return new Promise((resolve) => {
            let onMapReadyInterval = setInterval(() => {
                if(this.map.mapObject.loaded()) {
                    clearInterval(onMapReadyInterval);
                    resolve();
                }
            }, 500);
        });
    }

    setEvents() {
        this.setEditorOnWindowEvents();
        this.setStyleEvents();
        this.setPopularPlacesEvent();
        this.setAnywhereEvent();
        this.setChangeLegendEvent();
        this.setLegendStyleEvent();
        this.setAddToCartEvent();
        this.setUpdateCartEvent();
        this.setLegendTaglineEvents();
        this.setChangeSizeEvent();
        if(typeof fbq !== 'undefined') {
          fbq('track', 'CustomizeProduct');
        }
    }

    addGeocoder() {
        const geocoder = new MapboxGeocoder({
            language: locale,
            accessToken: mapboxgl.accessToken,
            flyTo: false,
            placeholder: geocoderPlaceholderText
        });

        const map = this.map.mapObject;
        const geocoderControl = $(".mapboxgl-ctrl-geocoder");

        if(geocoderControl.length != 0){
            geocoderControl.remove();
        }

        document.getElementById(this.searchInputId).appendChild(geocoder.onAdd(map));

        geocoder.on('result', (data) => {
            this.parseReverseGeo(data.result);
            map.flyTo({
                center: data.result.center,
                duration: 0,
                zoom: 12
            });
        });
    }

    parseReverseGeo(geoData) {
        let country, place;
        if(geoData.context){
            $.each(geoData.context, function(i, v){
              if(v.id.indexOf('country') >= 0) {
                country = v[`text_${locale}`];
              }
            });
        }

        place = geoData[`text_${locale}`];

        let update = {
            title: place || '',
            subtitle: country || '',
            tagline: this.prepareTagline(geoData.center)
        };

        updateYourMapObject(update);
        this.updateLegend(update);
    }

    prepareTagline (center) {
        if (!Array.isArray(center)) {
            return '';
        }

        return this.getNS(center[1]) +  ' / ' + this.getWE(center[0]);
    }

    getNS(n) {
        let side = (n > 0) ? 'N' : 'S';
        return this.getAbsAndRound(n, 3) + '°' + side;
    }

    getWE(n) {
        let side = (n > 0) ? 'E' : 'W';
        return this.getAbsAndRound(n, 3) + '°' + side;
    }

    getAbsAndRound (n, round) {
        return Math.abs(parseFloat(n).toFixed(round));
    }

    setEditorOnWindowEvents() {
        $(window).on('resize', () => {
            waitForFinalEvent(() => {
                this.mapSizeControl.adjustMapSize();
            }, 100, "map-resize");
        });
    }

    setActiveStyleClass(styleUrl) {
        let style = styleUrl.substr(styleUrl.lastIndexOf('/') + 1);
        $("li[data-style="+ style +"]").addClass('active');
    }

    setStyleEvents () {
        // Remove any existing event listeners to prevent duplicates (especially with Turbolinks)
        $('.styles-list li').off("click");
        $('.styles-list li').on("click", (e) => {
          let styleId = e.currentTarget.dataset.style;
          let style = 'mapbox://styles/skai/' + styleId;
          let styleElementObject = $(e.currentTarget);

          styleElementObject.siblings().removeClass('active');
          styleElementObject.addClass('active');
          this.map.mapObject.setStyle(style);
          this.onMapLoaded()
              .then(() => {
                  this.publish('map:style:change')
              });
          updateYourMapObject({ style: style });
        });

        return false;
    }

    setAnywhereEvent () {
        // Remove any existing event listeners to prevent duplicates (especially with Turbolinks)
        $('.anywhere').off("click");
        $('.anywhere').on("click", (e) => {
            const placesCount = parseInt(e.currentTarget.dataset.count);
            let id = Math.floor(Math.random() * placesCount + 1);
            this.updateMapByPlaceId(id);

            return false;
        });

    }

    setPopularPlacesEvent () {
        // Remove any existing event listeners to prevent duplicates (especially with Turbolinks)
        $('.popular-place').off("click");
        $('.popular-place').on("click", (e) => {
            let id = parseInt(e.currentTarget.dataset.id);
            this.updateMapByPlaceId(id);
            return false;
        });
    }

    setChangeLegendEvent () {
        this.setInputToLegendConnection(
            '#legend-title',
            '.map-legend .section-title span, .map-legend .labels .headline span',
            'title',
            '.map-legend .section-title, .map-legend .labels .headline'
        );
        this.setInputToLegendConnection(
            '#legend-subtitle',
            '.map-legend .sub-title, .map-legend .labels .divider span',
            'subtitle',
            '.map-legend .sub-title, .map-legend .labels .divider'
        );
        this.setInputToLegendConnection(
            '#legend-tagline',
            '.map-legend .tagline, .map-legend .labels .tagline span',
            'tagline',
            '.map-legend .tagline, .map-legend .labels .tagline'
        );
    }

    setLegendStyleEvent () {
        const legendStyle = this.normalizeLegendStyle(yourMap.legend_style);
        updateYourMapObject({ legend_style: legendStyle });
        this.setLegendStyle(legendStyle);
        $('.legend-style-input[value="' + legendStyle + '"]').prop('checked', true);

        $('.legend-style-input').off('change');
        $('.legend-style-input').on('change', (e) => {
            const style = this.normalizeLegendStyle(e.currentTarget.value);
            this.setLegendStyle(style);
            updateYourMapObject({ legend_style: style });
        });
    }

    setLegendStyle (style) {
        const legend = document.querySelector('.map-legend');
        if (!legend) { return; }
        const normalizedStyle = this.normalizeLegendStyle(style);
        legend.dataset.legendStyle = normalizedStyle;
        legend.classList.toggle('is-gradient', normalizedStyle === 'gradient');
        legend.classList.toggle('is-standard', normalizedStyle !== 'gradient');
    }

    normalizeLegendStyle (style) {
        if (style === 'labels') { return 'gradient'; }
        if (style === 'classic') { return 'standard'; }
        return style === 'gradient' ? 'gradient' : 'standard';
    }

    setAddToCartEvent() {
        // Remove any existing event listeners to prevent duplicates (especially with Turbolinks)
        $('.js-add-to-cart-btn').off('click');
        $('.js-add-to-cart-btn').on('click', () => {
            this.publish('onCartBtn:action');
            if(typeof fbq !== 'undefined') {
              fbq('track', 'AddToCart');
            }

            this.onMapLoaded()
                .then(() => this.addToCart())
                .then(this.onAddToOrUpdateCartSuccess)
                .catch((error)=>{ console.log(error) });
        });
    }

    setUpdateCartEvent() {
        // Remove any existing event listeners to prevent duplicates (especially with Turbolinks)
        $('.js-update-cart-btn').off('click');
        $('.js-update-cart-btn').on('click', () => {
            this.publish('onCartBtn:action');
            this.onMapLoaded()
                .then(() => this.updateCart())
                .then(this.onAddToOrUpdateCartSuccess)
                .catch((error)=>{ console.log(error) });
        });
    }

    addToCart(){
      return new Promise((resolve, reject) => {
          let postData = Object.assign(
              {
                  preview_image: this.map.mapObject.getCanvas().toDataURL("image/jpeg", 0.15),
                  product_id: 1,
              },
              yourMap,
              {
                  route: localStorageAPI.getString(),
                  bbox: JSON.stringify(this.map.mapObject.getBounds())
              }
          );
          $.ajax({
              url: `/${locale}/line_items.json`,
              type: "POST",
              data: postData,
              headers: {
                  'X-CSRF-Token': document.querySelector("meta[name=csrf-token]").content
              },
              success: function(data){
                  resolve(data)
              },
              error: function(errors){
                  reject(errors);
              }
          });
      });
    }

    updateCart(){
        return new Promise((resolve, reject) => {
            let itemId = yourMap.line_item_id;
            let putData = Object.assign(
                {
                    preview_image: this.map.mapObject.getCanvas().toDataURL("image/jpeg", 0.15),
                    product_id: 1,
                },
                yourMap,
                {
                    route: localStorageAPI.getString(),
                    bbox: JSON.stringify(this.map.mapObject.getBounds())
                }
            );
            $.ajax({
                url: `/${locale}/line_items/${itemId}.json`,
                type: "PUT",
                data: putData,
                headers: {
                    'X-CSRF-Token': document.querySelector("meta[name=csrf-token]").content
                },
                success: function(data){
                    resolve(data)
                },
                error: function(errors){
                    reject(errors);
                }
            });
        });
    }

    onAddToOrUpdateCartSuccess(data){
        Cookies.remove(localDataID);
        localStorageAPI.remove();
        window.location = data.redirect_to;
    }

    setInputToLegendConnection (inputSelector, legendSelector, yourMapObjectKey, legendContainerSelector = legendSelector) {
        $(inputSelector).bind('input', (e) => {
            if (!e.currentTarget.value.trim()) {  // if empty or whitespace
                $(legendContainerSelector).hide();
            } else {
                $(legendContainerSelector).show();
            }
            $(legendSelector).text(e.currentTarget.value);
            updateYourMapObject({ [yourMapObjectKey]: e.currentTarget.value });
            return false;
        });
    }

    updateMapByPlaceId(id) {
        let place = popularPlaces.find(function (obj) { return obj.id === id; });
        this.map.mapObject.flyTo({
            center: place.center,
            zoom: place.zoom,
            duration: 0
        });

        updateYourMapObject(place);
        this.updateLegend(place);
    }

    updateLegend(object) {
        $('.map-legend .section-title, .map-legend .labels .headline').show();
        $('.map-legend .section-title span, .map-legend .labels .headline span').text(object.title);
        $('.map-legend .sub-title, .map-legend .labels .divider').show();
        $('.map-legend .sub-title, .map-legend .labels .divider span').text(object.subtitle);
        $('.map-legend .tagline, .map-legend .labels .tagline').show();
        $('.map-legend .tagline, .map-legend .labels .tagline span').text(object.tagline);

        // update inputs in personalise tab.
        $('#legend-title').val(object.title);
        $('#legend-subtitle').val(object.subtitle);
        $('#legend-subtitle').val(object.subtitle);
        $('#legend-tagline').val(object.tagline);
    }

    setLegendTaglineEvents() {
        //TODO: move to the map class
        // Note: mapObject events are cleaned up when map is destroyed, so we don't need .off() here
        this.map.mapObject.on('moveend', () => {
            this.updateCoordinates();
        });
        // Remove any existing event listeners to prevent duplicates (especially with Turbolinks)
        $('#edit-coordinates-toggler').off('change');
        $('#edit-coordinates-toggler').on('change', () => {
            this.updateCoordinates();
        })
    }

    setChangeSizeEvent () {
        // Remove any existing event listeners to prevent duplicates (especially with Turbolinks)
        $('#content-3 .format-input').off('change');
        $('#content-3 .format-input').on('change', (e) => {
            this.mapSizeControl.changeMapSize(e.currentTarget.value);
            return false;
        });
    }

    updateCoordinates(){
        let center = this.map.getMapCenter();
        updateYourMapObject({ center: center });
        this.changeCoordinatesInEditor(center);
    }

    changeCoordinatesInEditor(mapCenter){
        if(!this.editCoordinatesEnabled()){ return; }
        const coordinates = this.prepareTagline(mapCenter);
        $('#legend-tagline').val(coordinates);
        $('#legend-tagline').trigger('input', [coordinates]);
    }

    editCoordinatesEnabled(){
        return document.getElementById('edit-coordinates-toggler').checked;
    }

    addRoute(routeData) {
        this.map.createRoute(routeData);
        this.updateDescription(routeData);
    }

    updateDescription(routeData) {
        const { title, subtitle, tagline ='' } = routeData;
        if (!title && !subtitle) { return; }
        this.updateLegend({ title, subtitle, tagline });
        updateYourMapObject({ title, subtitle, tagline})
    }

}

export default Editor;
